import { jsxs, jsx } from "react/jsx-runtime";
import assert from "assert";
import { Box } from "../Box/Box.mjs";
import { Text } from "../Text/Text.mjs";
import { TextLinkButton } from "../TextLinkButton/TextLinkButton.mjs";
import "../Text/TextContext.mjs";
import "../Heading/HeadingContext.mjs";
import "../../css/lineHeightContainer.css.mjs";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
import "../../css/reset/reset.css.mjs";
import "../../css/atoms/sprinkles.css.mjs";
import "../../hooks/useIcon/icon.css.mjs";
import "../../css/typography.css.mjs";
import { IconExpandLess } from "../icons/IconExpandLess/IconExpandLess.mjs";
import { IconExpandMore } from "../icons/IconExpandMore/IconExpandMore.mjs";
import { useDisclosure } from "./useDisclosure.mjs";
import { AvoidWidowIcon } from "../private/AvoidWidowIcon/AvoidWidowIcon.mjs";
const Disclosure = ({
  id,
  expandLabel,
  collapseLabel = expandLabel,
  space = "medium",
  children,
  data,
  ...restProps
}) => {
  assert(
    typeof expandLabel === "undefined" || typeof expandLabel === "string",
    "'expandLabel' must be a string"
  );
  assert(
    typeof collapseLabel === "undefined" || typeof collapseLabel === "string",
    "'collapseLabel' must be a string"
  );
  const { expanded, buttonProps, contentProps } = useDisclosure({
    id,
    ...restProps.expanded !== void 0 ? {
      onToggle: restProps.onToggle,
      expanded: restProps.expanded
    } : {
      onToggle: restProps.onToggle
    }
  });
  return /* @__PURE__ */ jsxs(Box, { ...buildDataAttributes({ data, validateRestProps: restProps }), children: [
    /* @__PURE__ */ jsx(Box, { userSelect: "none", children: /* @__PURE__ */ jsx(Text, { children: /* @__PURE__ */ jsxs(TextLinkButton, { hitArea: "large", ...buttonProps, children: [
      expanded ? collapseLabel : expandLabel,
      /* @__PURE__ */ jsx(AvoidWidowIcon, { iconPosition: "trailing", children: expanded ? /* @__PURE__ */ jsx(IconExpandLess, { alignY: "lowercase" }) : /* @__PURE__ */ jsx(IconExpandMore, { alignY: "lowercase" }) })
    ] }) }) }),
    /* @__PURE__ */ jsx(Box, { paddingTop: space, display: expanded ? "block" : "none", ...contentProps, children })
  ] });
};
export {
  Disclosure
};
